"use strict";

/**
 * @author Maxim Seredkin
 * @param {*} $scope
 * @param {*} $rootScope
 * @param {*} $utils
 * @param {*} OperatorService
 * @param {*} SupportStageService
 * @param {*} ProjectService
 */
export default [
  "$scope",
  "$rootScope",
  "$utils",
  "OperatorService",
  "SupportStageService",
  "ProjectService",
  "SettingsService",
  "IndustryService",
  "MilestoneService",
  "MunicipalityService",
  "Notification",
  function (
    $scope,
    $rootScope,
    $utils,
    OperatorService,
    SupportStageService,
    ProjectService,
    SettingsService,
    IndustryService,
    MilestoneService,
    MunicipalityService,
    Notification
  ) {
    $rootScope.title = "";

    $scope.getOperatorDisplayName = OperatorService.getDisplayName;
    $scope.openControlSidebar = $utils.openControlSidebar;
    $scope.isBetween = OperatorService.isBetween;
    // $scope.hideFilters = hideFilters;
    $scope.selectSettings = { ...$rootScope.selectSettings };
    $scope.selectTranslation = { ...$rootScope.selectTranslation };

    $scope.filter = {};
    $scope.localFilter = ProjectService.getOtherFilters();
    $scope.localFiltersArray = [];

    $scope.oldFilters = [];
    $scope.filters = [];

    $scope.stages = [];
    $scope.industries = [];
    $scope.milestones = [];

    $scope.searchFilterRequestParams = [];

    $scope.openNotifyModal = openNotifyModal;

    $scope.updateScopeFilters = updateScopeFilters;

    console.log("w1", $scope.localFilter);
    if ($rootScope.isFromProjectPage) {
      const localFilterStorage = sessionStorage.getItem("localFilter");
      if (localFilterStorage) {
        $scope.localFilter = JSON.parse(localFilterStorage);
      }
    }

    function updateScopeFilters(newFilters) {
      $scope.filters = newFilters;
    }
    function openNotifyModal(filters, searchs) {
      ProjectService.notify(filters, searchs);
    }

    $scope.setOEZFilter = (type) => {
      if (type === "all") {
        $scope.localFilter.area = undefined;
        $scope.localFilter.isGCHP = undefined;
      } else if (type === "oez") {
        $scope.localFilter.area = $scope.localFilter.area
          ? undefined
          : { id: 8, name: "ОЭЗ", status: "ENABLED", npp: 5 };
      } else if (type === "gchp") {
        $scope.localFilter.isGCHP = !$scope.localFilter.isGCHP;
      }
    };

    $scope.years = Array(101)
      .fill(null)
      .map((_, index) => ({
        id: index ? 1999 + index : null,
        name: index ? 1999 + index : " ",
      }));
    $scope.municipalities = [];
    $scope.reportTypes = [
      {
        name: "Сводный отчет",
        id: 0,
        action: "api/reports/registry",
      },
      {
        name: "Резервная копия",
        id: 1,
        action: "api/reports/backup",
      },
      {
        name: "Инвестиционный план",
        id: 2,
        action: "api/reports/plan",
      },
      {
        name: "Отчет ФСО",
        id: 3,
        action: "api/reports/fso",
      },
      {
        name: "Отчет для Росстат",
        id: 4,
        action: "api/reports/rosstat",
      },
      {
        name: "Отчет о реализуемых концессиях и соглашениях о МЧП",
        id: 5,
        action: "api/reports/mchp",
      },
      {
        name: "Отчет о проектах ОЭЗ",
        id: 6,
        action: "api/reports/oez",
      },
      {
        name: "Общий отчет по проектам",
        id: 7,
        action: "api/reports/total",
      },
      {
        name: "Мониторинг",
        id: 8,
        action: "api/reports/monitoring",
      },
    ];
    $scope.reportFilterDefaults = {
      activeReportType: $scope.reportTypes[0],
      isBackupAll: true,
      municipality: null,
      startYear: null,
      endYear: null,
    };
    $scope.reportFilter = { ...$scope.reportFilterDefaults };
    $scope.isOpenReportModal = false;
    $scope.toggleReportModal = function () {
      if ($scope.isOpenReportModal) {
        $scope.reportFilter = { ...$scope.reportFilterDefaults };
      }
      $scope.isOpenReportModal = !$scope.isOpenReportModal;
    };

    $scope.isMunicipalVisible = (activeReportType) => {
      return ![0, 1].includes(activeReportType);
    };

    $scope.isPeriodVisible = (activeReportType) => {
      return ![0, 1].includes(activeReportType);
    };

    $scope.generateReport = () => {
      const activeReport = $scope.reportTypes.find(
        (item) => item.id === $scope.reportFilter.activeReportType.id
      );
      let requestQueryParams = new URLSearchParams({});
      const isBackupAllProjects =
        activeReport.id === 1 && $scope.reportFilter.isBackupAll;

      if (!isBackupAllProjects) {
        requestQueryParams = new URLSearchParams(
          $scope.getFilterRequestsParam()
        );
      }
      if (
        $scope.isMunicipalVisible(activeReport.id) &&
        $scope.reportFilter.municipality
      ) {
        requestQueryParams.set(
          "municipality",
          $scope.reportFilter.municipality.id
        );
      }
      if ($scope.isPeriodVisible(activeReport.id)) {
        if (
          $scope.reportFilter.startYear &&
          $scope.reportFilter.startYear.id != null
        ) {
          requestQueryParams.set("startYear", $scope.reportFilter.startYear.id);
        }
        if (
          $scope.reportFilter.endYear &&
          $scope.reportFilter.endYear.id != null
        ) {
          requestQueryParams.set("endYear", $scope.reportFilter.endYear.id);
        }
      }

      $scope.loadingDownload = true;

      fetch(`${activeReport.action}?${requestQueryParams.toString()}`)
        .then((res) => {
          let filename = res.headers
            .get("Content-Disposition")
            .split("filename=")[1];

          res
            .blob()
            .then((blob) => {
              const a = document.createElement("a");
              a.target = "_self";
              a.href = URL.createObjectURL(blob);
              a.download =
                filename ||
                `${activeReport.name}_${new Date().toLocaleDateString()}.xlsx`;
              a.click();
              URL.revokeObjectURL(a.href);
              if ($scope.isOpenReportModal) $scope.isOpenReportModal = false;
              $scope.loadingDownload = false;
              $scope.$apply();
            })
            .catch((err) => {
              Notification.danger({
                title: "Ошибка загрузки отчета",
              });
              $scope.loadingDownload = false;
              $scope.$apply();
            });
        })
        .catch((err) => {
          Notification.danger({
            title: "Ошибка загрузки отчета",
          });
          $scope.loadingDownload = false;
          $scope.$apply();
        });
    };

    $scope.uploadBackup = (file) => {
      let fileType = null;
      if (
        [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ].includes(file.type)
      ) {
        fileType = "XLS";
      }
      if (["application/zip"].includes(file.type)) {
        fileType = "ZIP";
      }
      if (!fileType) {
        Notification.error({
          title: "Неверный формат файла",
          message: "Загрузите файл в формате xls, zip",
        });
        return;
      }
      $scope.loadingUpload = true;
      const form = new FormData();
      form.append("file", file);
      form.append("type", fileType);
      fetch("/api/reports/backup", {
        method: "POST",
        body: form,
      })
        .then((res) => {
          $scope.loadingUpload = false;
          Notification.success({ message: "Файл успешно загружен" });
          $scope.$apply();
        })
        .catch((err) => {
          Notification.error({
            title: "Ошибка загрузки файла",
            message: err.toString ? err.toString() : "",
          });
          $scope.loadingUpload = false;
          $scope.$apply();
        });
    };

    init();

    /**
     * Инициализация
     */
    function init() {
      //$scope.localFilter =

      SupportStageService.api.get(
        { sorts: ["npp:ASC", "name:ASC"] },
        (data) => {
          $scope.stages = [
            {
              id: null,
              name: "Все",
              stage: "ALL_STAGE",
            },
          ].concat(data._embedded);
        }
      );

      IndustryService.api.get(
        {
          filters: [`'status' EQ 'ENABLED'`],
          sorts: ["npp:ASC", "name:ASC"],
        },
        (data) => ($scope.industries = data._embedded)
      );

      MilestoneService.api.get({ sorts: ["npp:ASC", "name:ASC"] }, (data) => {
        $scope.milestones = [
          {
            id: null,
            name: "Все",
          },
        ].concat(data._embedded);
      });

      MunicipalityService.api.get(
        {
          filters: [`'status' EQ 'ENABLED'`],
          sorts: ["npp:ASC", "name:ASC"],
        },
        (data) => ($scope.municipalities = data._embedded)
      );

      // Добавляем формат даты для датапикера
      $scope.dateFormat = "yyyy";

      // Инициализируем значение если его нет
      if (!$scope.localFilter.planEndYear) {
        $scope.localFilter.planEndYear = null;
      }
    }

    /**
     * Спрятал фильтра
     */
    // function hideFilters() {
    //     if ($scope.filters.length > 0) {
    //         $scope.oldFilters = $scope.filters;
    //         $scope.filters = [];
    //     } else {
    //         $scope.isSetFilters = false;
    //         $scope.filters = $scope.oldFilters;
    //     }
    // }

    // $scope.$watch('filters', function(nv, oldv) {
    //     if (angular.equals(nv,oldv)) return;
    //     $scope.isSetFilters = $scope.filters.length > 0;
    // });

    $scope.$watch("milestones", function (nv, oldv) {
      if (angular.equals(nv, oldv)) return;

      $scope.localFiltersArray = $scope.convertLocalFiltersArray();
    });

    $scope.$watch(
      "localFilter",
      function (nv, oldv) {
        if (angular.equals(nv, oldv)) return;

        ProjectService.setOtherFilters($scope.localFilter);
        sessionStorage.setItem(
          "localFilter",
          JSON.stringify($scope.localFilter)
        );

        $scope.localFiltersArray = $scope.convertLocalFiltersArray();
      },
      true
    );

    $scope.$watch(
      "localFilter.industry",
      function (nv, oldv) {
        if (angular.equals(nv, oldv)) return;
        ProjectService.setOtherFilters($scope.localFilter);
        $scope.localFiltersArray = $scope.convertLocalFiltersArray();
      },
      true
    );

    $scope.$watch(
      "localFilter.area",
      function (nv, oldv) {
        if (angular.equals(nv, oldv)) return;
        ProjectService.setOtherFilters($scope.localFilter);
        $scope.localFiltersArray = $scope.convertLocalFiltersArray();
      },
      true
    );

    $scope.$watch(
      "localFilter.isGCHP",
      function (nv, oldv) {
        if (angular.equals(nv, oldv)) return;
        ProjectService.setOtherFilters($scope.localFilter);
        $scope.localFiltersArray = $scope.convertLocalFiltersArray();
      },
      true
    );

    $scope.$watch(
      "localFilter.planEndYear",
      function (nv, oldv) {
        if (angular.equals(nv, oldv)) return;
        ProjectService.setOtherFilters($scope.localFilter);
        $scope.localFiltersArray = $scope.convertLocalFiltersArray();
      },
      true
    );

    $scope.convertLocalFiltersArray = function () {
      let filters = [];
      if (!!$scope.localFilter.hasExpirationMaintenance) {
        if ($scope.localFilter.hasExpirationMaintenance === "EXPIRED") {
          filters.push(`'hasExpirationMaintenance' EQ 'true'`);
        } else if (
          $scope.localFilter.hasExpirationMaintenance === "NOT_EXPIRED"
        ) {
          filters.push(`'hasExpirationMaintenance' EQ 'false'`);
        }
      }

      if (
        $scope.localFilter.area != null &&
        $scope.localFilter.area.id != null
      ) {
        filters.push(`'area.id' EQ '${$scope.localFilter.area.id}'`);
      }

      if ($scope.localFilter.isGCHP) {
        filters.push(`'isGCHP' EQ '${$scope.localFilter.isGCHP}'`);
      }

      if (
        Array.isArray($scope.localFilter.industry) &&
        $scope.localFilter.industry.length
      ) {
        filters.push(
          `EXTRA:'industry' EQ '${$scope.localFilter.industry
            .map((n) => "" + n.id)
            .join(";")}'`
        );
      }

      if (!!$scope.localFilter.milestone) {
        filters.push(`EXTRA:'milestone' EQ '${$scope.localFilter.milestone}'`);
      } else {
        let myMilestone = $scope.milestones.find(
          (el) => el.name === "Реализованные"
        );

        if (myMilestone)
          filters.push(`EXTRA:'milestone' NE '${myMilestone.id}'`);
      }

      if ($scope.localFilter.planEndYear) {
        // Убедимся что у нас есть корректное значение года
        let year;
        if ($scope.localFilter.planEndYear instanceof Date) {
          year = $scope.localFilter.planEndYear.getFullYear();
        } else if (typeof $scope.localFilter.planEndYear === "number") {
          year = $scope.localFilter.planEndYear;
        }

        if (year) {
          filters.push(`'planEndYear' EQ '${year}'`);
        }
      }

      filters.push(`'entityStatus' EQ 'ENABLED'`);

      return filters;
    };

    $scope.getFiltersWithLocalFilters = function () {
      let filters = angular.copy($scope.localFiltersArray);

      if (Array.isArray($scope.filters)) {
        filters = filters.concat($scope.filters);
      }

      return filters;
    };

    $scope.getFilterRequestsParam = () => {
      const filters = $scope.getFiltersWithLocalFilters();
      let filtersRequestParams = "";
      let searchRequestParams = "";

      if (filters.length > 0) {
        filtersRequestParams = filters
          .map((item) => `filters=${item}`)
          .join("&");
      }

      if ($scope.searchFilterRequestParams.length > 0) {
        searchRequestParams = $scope.searchFilterRequestParams
          .map((item) => `searchs=${item}`)
          .join("&");
      }

      return (
        "?" +
        [filtersRequestParams, searchRequestParams]
          .filter((item) => item.length > 0)
          .join("&")
      );
    };
  },
];
